import { useMutation } from '@apollo/client/react';
import { useContext } from 'react';
import { toast } from 'react-toastify';

import { AppContext } from '../App';
import { Kitchen } from '../libs';
import { TRIGGER_TOP_CONTROL_SYNC_MUTATION } from '../libs/graphQL';

type TriggerTopControlSyncData = {
  triggerTopControlSync: {
    message: string;
  } | null;
};

const useTriggerTopControlSyncMutation = () => {
  const [triggerTopControlSync, { loading }] = useMutation<TriggerTopControlSyncData>(TRIGGER_TOP_CONTROL_SYNC_MUTATION);
  const { user } = useContext(AppContext);

  const handleTriggerTopControlSync = async ({ kitchen, day, url }: { kitchen: Kitchen; day: string; url: string }) => {
    try {
      const { data } = await triggerTopControlSync({ variables: { kitchen, day, url, email: user.email } });
      toast.success(data?.triggerTopControlSync?.message ?? 'Processing — you will receive an email shortly.');
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to trigger Top Control sync');
    }
  };

  return { handleTriggerTopControlSync, loading };
};

export default useTriggerTopControlSyncMutation;
